module.exports = __webpack_public_path__ + "static/media/yellowStart.10f7560c.svg";